import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, change as onChange } from 'redux-form';
import { translate as t } from 'admin-on-rest';
import {
  List,
  FlatButton,
} from 'material-ui';
import CreateIcon from 'material-ui/svg-icons/content/add';
import QuestionForm from './Question/QuestionForm';
import {
  defaultSingleSelect, defaultMultipleSelect, defaultBinary,
  defaultPair, defaultSorting, defaultImageSelect,
} from './Question';


class QuestionListBuilder extends React.Component {
  getPreviousQuestions = () => {
    const { checkpointId } = this.props;
    const checkpoint = this.props.quiz.checkpoints.find((c) => c.id === checkpointId);
    return checkpoint ? (checkpoint.questions || []) : [];
  }

  defaultQuestion = () => {
    const randomInteger = Math.floor(Math.random() * 1000);
    const now = new Date().getTime();
    return {
      id: `${now}${randomInteger}`,
    };
  }

  createImageSelect = () => {
    this.createQuestion(defaultImageSelect());
  }
  createSorting = () => {
    this.createQuestion(defaultSorting());
  }
  createPair = () => {
    this.createQuestion(defaultPair());
  }
  createBinary = () => {
    this.createQuestion(defaultBinary());
  }
  createSingleSelect = () => {
    this.createQuestion(defaultSingleSelect());
  }
  createMultipleSelect = () => {
    this.createQuestion(defaultMultipleSelect());
  }

  createQuestion = (question) => {
    const prevQuestions = this.getPreviousQuestions();
    this.callChangeState([...prevQuestions, question]);
  }

  updateQuestion = (delta, id) => {
    const prevQuestions = this.getPreviousQuestions();
    const nextQuestions = prevQuestions.map((question) => {
      if (question.id === id) {
        return { ...question, ...delta };
      }
      return question;
    });
    this.callChangeState(nextQuestions);
  }

  deleteQuestion = (id) => {
    const prevQuestions = this.getPreviousQuestions();
    const nextQuestions = prevQuestions.filter((q) => q.id !== id);
    this.callChangeState(nextQuestions);
  }

  callChangeState = (listOfQuestions) => {
    const { checkpointId } = this.props;
    const idx = this.props.quiz.checkpoints.findIndex((c) => c.id === checkpointId);
    this.props.change('record-form', `checkpoints.${idx}.questions`, listOfQuestions);
  }

  render() {
    const { path } = this.props;
    const questions = this.getPreviousQuestions().map((q, idx) => (
      <QuestionForm
        {...q}
        key={q.id}
        path={`${path}.questions.${idx}`}
        headerTitle={`${idx + 1}. ${q.title || ''}`}
        onChange={this.updateQuestion}
        onRemove={this.deleteQuestion}
      />
    ));
    return (
      <>
        <h3>{this.props.translate('resources.quizes.fields.questions')}</h3>
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.singleSelect'),
          })}
          onClick={this.createSingleSelect}
          icon={<CreateIcon />}
        />
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.multipleSelect'),
          })}
          onClick={this.createMultipleSelect}
          icon={<CreateIcon />}
        />
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.binary'),
          })}
          onClick={this.createBinary}
          icon={<CreateIcon />}
        />
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.pair'),
          })}
          onClick={this.createPair}
          icon={<CreateIcon />}
        />
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.sort'),
          })}
          onClick={this.createSorting}
          icon={<CreateIcon />}
        />
        <FlatButton
          label={this.props.translate('create.item', {
            item: this.props.translate('resources.quizes.questions.imageSelect'),
          })}
          onClick={this.createImageSelect}
          icon={<CreateIcon />}
        />
        <List>
          {questions}
        </List>
    </>
    );
  }
}

const selector = getFormValues('record-form');

export default connect(
  (state) => ({
    quiz: selector(state),
  }),
  { change: onChange }
)(t(QuestionListBuilder));
